import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CountdownService {
  public targetDate: Date; // Replace with your target date
  public remainingTime: {
    hours: number | string;
    minutes: number | string;
    seconds: number | string;
  };
  public finishedTest$ = new EventEmitter<boolean>();
  private _canEmit = true;
  private _interval;

  startTime() {
    this.updateRemainingTime();
    this._interval = setInterval(() => this.updateRemainingTime(), 1000);
  }

  updateRemainingTime() {
    const currentDate = new Date();
    const diffInSeconds =
      Math.abs(this.targetDate.getTime() - currentDate.getTime()) / 1000;

    const minutes = Math.floor((diffInSeconds % 3600) / 60);
    const hours = Math.floor(diffInSeconds / 3600);
    const seconds = Math.floor(diffInSeconds % 60);

    this.remainingTime = {
      hours: hours < 10 ? `0${hours}` : hours,
      minutes: minutes < 10 ? `0${minutes}` : minutes,
      seconds: seconds < 10 ? `0${seconds}` : seconds,
    };
    if (
      !Number(this.remainingTime.hours) &&
      !Number(this.remainingTime.minutes) &&
      !Number(this.remainingTime.seconds)
    ) {
      clearInterval(this._interval);
      if (this._canEmit) {
        this.finishedTest$.emit(true);
      }
      this._canEmit = false;
    }
  }
}
